import _ from "lodash";
import { User, UserColleagues } from "models/user.model";
import { UserContextData } from "ts-utils-lib";

const getUser = (userData: User) => {
    if (_.isEmpty(userData)) {
        return null;
    }
    return userData;
};

const getProduct = (userColleagues: UserColleagues) => {
    if (_.isEmpty(userColleagues)) {
        return null;
    }
    return userColleagues;
};

const getEnvironments = (environmentData: any) => {
    if (_.isEmpty(environmentData)) {
        return null;
    }
    return environmentData?.CustomerEnvironment;
};

const setEnvironmentDetailsToLocalStorage = (environment: {name: string, id: string, displayName: string}) => {
    UserContextData.SetEnvironmentName(environment.name) 
    UserContextData.SetEnvironmentId(environment.id) 
    UserContextData.SetEnvironmentDisplayName(environment.displayName) 
}

export const initializeAppContext = (
    userData: User,
    environmentList: any,
    setAuth: Function,
    setEnvironment: Function
) => {
    const user = getUser(userData);

    const currentEnvId = localStorage.getItem('environmentId');
    let selectedEnvironment = environmentList?.find(env => env.id == currentEnvId);
    if(!selectedEnvironment){
        selectedEnvironment = environmentList?.[0];
    }
    
    const environment = selectedEnvironment || { displayName: "Development", name: "dev" };

    setAuth({ ...user});
    setEnvironment(environment);
    setEnvironmentDetailsToLocalStorage(environment);
};
